import classNames from 'classnames'
import InfoIcon from '../Icons/InfoIcon'

const InfoIconBlock = ({ info_msg, withBg }) => {
  return (
    <div className={classNames('info_icon_block', { withBg })}>
      <InfoIcon className="info_icon" />
      <span className="info_icon_msg">{info_msg}</span>
    </div>
  )
}

export default InfoIconBlock
